import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=148d22d0&scoped=true&"
import script from "./Qualification.vue?vue&type=script&lang=js&"
export * from "./Qualification.vue?vue&type=script&lang=js&"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=148d22d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d22d0",
  null
  
)

export default component.exports